import { SideNavMenu } from "@/components/side-nav-menu/side-nav";
import companyProfileIcon from "@/assets/myaccount/company-profile@2x.webp";
import accountSettingIcon from "@/assets/myaccount/account-settings@2x.webp";
import integrationIcon from "@/assets/myaccount/integration@2x.webp";
import userProfileIcon from "@/assets/myaccount/user-profile@2x.webp";
import organizationUserIcon from "@/assets/myaccount/org-users@2x.webp";
import subscriptionIcon from "@/assets/myaccount/subscription.webp";
import builderWatchlistIcon from "@/assets/myaccount/watchlist@2x.webp"
import Arrow from "@/assets/myaccount/arrow.svg";
const MyAccountPage = () => {
  const LINK_ICON_STYLE = "size-[25px] flex-shrink-0 hover:scale-125";
  const menuItems = [
       { label: "My Account", href: "my-account",icon: (
      <img
        src={Arrow}
        alt="all apps icon"
        className={LINK_ICON_STYLE}
        title="My Account"
      />
    ), },
    { label: "Company Profile", href: "company-profile",icon: (
      <img
        src={companyProfileIcon}
        alt="all apps icon"
        className={LINK_ICON_STYLE}
        title="Company Profile"
      />
    ), },
    { label: "User Profile", href: "user-profile",icon: (
      <img
        src={userProfileIcon}
        alt="all apps icon"
        className={LINK_ICON_STYLE}
        title="User Profile"
      />
    ), },
    { label: "Account Setting", href: "account-setting",icon: (
      <img
        src={accountSettingIcon}
        alt="all apps icon"
        className={LINK_ICON_STYLE}
        title="Account Setting"
      />
    ), },
    { label: "Integrations", href: "integrations" ,icon: (
      <img
        src={integrationIcon}
        alt="all apps icon"
        className={LINK_ICON_STYLE}
        title="Integrations"
      />
    ),},
    { label: "Subscriptions", href: "subscription",icon: (
      <img
        src={subscriptionIcon}
        alt="all apps icon"
        className={LINK_ICON_STYLE}
        title="Subscriptions"
      />
    ), },
    { label: "Organizations Users", href: "organization-users",icon: (
      <img
        src={organizationUserIcon}
        alt="all apps icon"
        className={LINK_ICON_STYLE}
        title="Organizations Users"
      />
    ), },
    { label: "Builder Watchlist", href: "builder-watchlist",icon: (
      <img
        src={builderWatchlistIcon}
        alt="all apps icon"
        className={LINK_ICON_STYLE}
        title="Builder Watchlist"
      />
    ), },
  ];

  return <SideNavMenu navLinks={menuItems} />;
};

export default MyAccountPage;
